export enum AuditActionType {
  ADD = 'ADD',
  DATA_EXPORT = 'DATA_EXPORT',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  UPDATE = 'UPDATE'
}

export enum AuditApplicationArea {
  ADMIN = 'ADMIN',
  CENTRAL_MONITORING = 'CENTRAL_MONITORING',
  CENTRAL_MONITORING_2 = 'CENTRAL_MONITORING_2',
  DATA_QUALITY = 'DATA_QUALITY',
  IMPORT = 'IMPORT',
  ISMP = 'ISMP',
  OPRA = 'OPRA',
  OPRA_PLUGIN = 'OPRA_PLUGIN',
  ORGANISATION = 'ORGANISATION',
  PANEL = 'PANEL',
  REPORT = 'REPORT',
  RISK_ASSESSMENT = 'RISK_ASSESSMENT',
  SITE = 'SITE',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT',
  SUBJECT_MONITORING = 'SUBJECT_MONITORING',
  SUBJECT_MONITORING_REVIEW = 'SUBJECT_MONITORING_REVIEW'
}

export enum AuditDataType {
  ACTIONS = 'ACTIONS',
  ALL = 'ALL',
  CENTRAL_MONITORING_OBSERVATION = 'CENTRAL_MONITORING_OBSERVATION',
  CENTRAL_MONITORING_OBSERVATION_ACTION = 'CENTRAL_MONITORING_OBSERVATION_ACTION',
  CM_2_ACTION = 'CM_2_ACTION',
  CM_2_OBSERVATION = 'CM_2_OBSERVATION',
  CM_2_REVIEW_LOG = 'CM_2_REVIEW_LOG',
  CM_INTEGRATION_CONFIG = 'CM_INTEGRATION_CONFIG',
  CONTROLS = 'CONTROLS',
  CONTROLS_HUB_CONFIG_PANEL = 'CONTROLS_HUB_CONFIG_PANEL',
  CONTROLS_HUB_CONFIG_WIDGET = 'CONTROLS_HUB_CONFIG_WIDGET',
  CONTROLS_HUB_WIDGET = 'CONTROLS_HUB_WIDGET',
  CRITICAL_VARIABLE = 'CRITICAL_VARIABLE',
  CTQ_COMMENT = 'CTQ_COMMENT',
  CTQ_COMMENT_REPLY = 'CTQ_COMMENT_REPLY',
  DASHBOARD = 'DASHBOARD',
  DASHBOARDS = 'DASHBOARDS',
  DATASET_IMPORT_LOG = 'DATASET_IMPORT_LOG',
  DATA_PROCESSING_LOG = 'DATA_PROCESSING_LOG',
  DATA_QUALITY_REPORT = 'DATA_QUALITY_REPORT',
  DATA_REVIEW_TABLE = 'DATA_REVIEW_TABLE',
  DATA_SET = 'DATA_SET',
  DATA_SET_REVIEW = 'DATA_SET_REVIEW',
  DATA_SOURCE = 'DATA_SOURCE',
  DATA_VIEW_CONFIGURATION = 'DATA_VIEW_CONFIGURATION',
  DATA_VIEW_FILTER = 'DATA_VIEW_FILTER',
  EXCEL_EXPORT = 'EXCEL_EXPORT',
  EXCEL_LISTING = 'EXCEL_LISTING',
  EXTRA_DATA_FIELD = 'EXTRA_DATA_FIELD',
  FUNCTIONAL_DATA_REVIEW = 'FUNCTIONAL_DATA_REVIEW',
  IMPORT_STATE = 'IMPORT_STATE',
  INDICATORS = 'INDICATORS',
  INVESTIGATOR = 'INVESTIGATOR',
  ISMP = 'ISMP',
  KRI_REVIEW = 'KRI_REVIEW',
  LIBRARY_CONTROL = 'LIBRARY_CONTROL',
  LIBRARY_FUNCTIONAL_DATA_REVIEW = 'LIBRARY_FUNCTIONAL_DATA_REVIEW',
  LIBRARY_RISK = 'LIBRARY_RISK',
  LOCATION = 'LOCATION',
  LO_VS = 'LO_VS',
  NAMED_ITEM = 'NAMED_ITEM',
  OBSERVATIONS = 'OBSERVATIONS',
  ORGANISATION = 'ORGANISATION',
  ORGANISATION_CONTACT = 'ORGANISATION_CONTACT',
  ORGANISATION_INDICATION = 'ORGANISATION_INDICATION',
  ORGANISATION_MEMBER = 'ORGANISATION_MEMBER',
  ORGANISATION_PRODUCT = 'ORGANISATION_PRODUCT',
  ORGANISATION_PROGRAM = 'ORGANISATION_PROGRAM',
  ORGANISATION_ROLE = 'ORGANISATION_ROLE',
  PANEL = 'PANEL',
  PBICM_2_REPORT_SIGNATORY = 'PBICM_2_REPORT_SIGNATORY',
  PBICM_REPORT_SIGNATORY = 'PBICM_REPORT_SIGNATORY',
  PBIOPRA_REPORT_TEMPLATE = 'PBIOPRA_REPORT_TEMPLATE',
  PBIRAM_REPORT_SIGNATORY = 'PBIRAM_REPORT_SIGNATORY',
  PBISM_REPORT_SIGNATORY = 'PBISM_REPORT_SIGNATORY',
  PBI_CUSTOM_REPORT_TEMPLATE = 'PBI_CUSTOM_REPORT_TEMPLATE',
  PBI_REPORT = 'PBI_REPORT',
  PBI_RISK_REVIEW = 'PBI_RISK_REVIEW',
  PBI_RISK_REVIEW_ATTENDEE = 'PBI_RISK_REVIEW_ATTENDEE',
  PLUGIN = 'PLUGIN',
  REPORT = 'REPORT',
  REPORT_DEFINITION = 'REPORT_DEFINITION',
  REPORT_SIGNATORY = 'REPORT_SIGNATORY',
  REVIEW_POINTS = 'REVIEW_POINTS',
  RISKS = 'RISKS',
  RISK_ACTION = 'RISK_ACTION',
  RISK_ASSESSMENT_TAG = 'RISK_ASSESSMENT_TAG',
  RISK_COMMENT = 'RISK_COMMENT',
  RISK_COMMENT_REPLY = 'RISK_COMMENT_REPLY',
  RISK_DASHBOARD_SETUP = 'RISK_DASHBOARD_SETUP',
  RISK_EVALUATION = 'RISK_EVALUATION',
  RISK_EVALUATION_MODEL = 'RISK_EVALUATION_MODEL',
  RISK_OBSERVATION = 'RISK_OBSERVATION',
  SITE = 'SITE',
  SITE_ISSUE = 'SITE_ISSUE',
  SITE_PROTOCOL_DEVIATION = 'SITE_PROTOCOL_DEVIATION',
  SITE_REVIEW = 'SITE_REVIEW',
  SITE_VISIT = 'SITE_VISIT',
  SM_STUDY_MEMBER = 'SM_STUDY_MEMBER',
  STUDY = 'STUDY',
  STUDY_ASSESSMENT = 'STUDY_ASSESSMENT',
  STUDY_COHORT = 'STUDY_COHORT',
  STUDY_CONTROL = 'STUDY_CONTROL',
  STUDY_COUNTRY = 'STUDY_COUNTRY',
  STUDY_CRF = 'STUDY_CRF',
  STUDY_DASHBOARD_CONFIG = 'STUDY_DASHBOARD_CONFIG',
  STUDY_DASHBOARD_CONFIGURATION = 'STUDY_DASHBOARD_CONFIGURATION',
  STUDY_DASHBOARD_CONFIG_PANEL = 'STUDY_DASHBOARD_CONFIG_PANEL',
  STUDY_DASHBOARD_CONFIG_WIDGET = 'STUDY_DASHBOARD_CONFIG_WIDGET',
  STUDY_HUB_SITE_FIELDS = 'STUDY_HUB_SITE_FIELDS',
  STUDY_HUB_STUDY_FIELDS = 'STUDY_HUB_STUDY_FIELDS',
  STUDY_MEMBER = 'STUDY_MEMBER',
  STUDY_SUBJECT_VISIT_OVER_TIME = 'STUDY_SUBJECT_VISIT_OVER_TIME',
  STUDY_SUBJECT_VISIT_SCHEDULE_TEMPLATE = 'STUDY_SUBJECT_VISIT_SCHEDULE_TEMPLATE',
  STUDY_TREATMENT_ARM = 'STUDY_TREATMENT_ARM',
  SUBJECT = 'SUBJECT',
  SUBJECT_ACTIONS = 'SUBJECT_ACTIONS',
  SUBJECT_ADVERSE_EVENT = 'SUBJECT_ADVERSE_EVENT',
  SUBJECT_ASSESSMENT = 'SUBJECT_ASSESSMENT',
  SUBJECT_CONCOMITANT_MEDICATION = 'SUBJECT_CONCOMITANT_MEDICATION',
  SUBJECT_CRF = 'SUBJECT_CRF',
  SUBJECT_DATA_LISTING_REVIEW = 'SUBJECT_DATA_LISTING_REVIEW',
  SUBJECT_INFORMED_CONSENT = 'SUBJECT_INFORMED_CONSENT',
  SUBJECT_ISSUE = 'SUBJECT_ISSUE',
  SUBJECT_LAB = 'SUBJECT_LAB',
  SUBJECT_MEDICAL_HISTORY = 'SUBJECT_MEDICAL_HISTORY',
  SUBJECT_MONITORING_DATA_LISTINGS_CONFIG = 'SUBJECT_MONITORING_DATA_LISTINGS_CONFIG',
  SUBJECT_MONITORING_REVIEW = 'SUBJECT_MONITORING_REVIEW',
  SUBJECT_MONITORING_REVIEW_PLAN = 'SUBJECT_MONITORING_REVIEW_PLAN',
  SUBJECT_MONITORING_REVIEW_TYPE = 'SUBJECT_MONITORING_REVIEW_TYPE',
  SUBJECT_MONITORING_SUBJECT_HUB_OVERVIEW_GRID_CONFIG = 'SUBJECT_MONITORING_SUBJECT_HUB_OVERVIEW_GRID_CONFIG',
  SUBJECT_OBSERVATIONS = 'SUBJECT_OBSERVATIONS',
  SUBJECT_PROFILE_DETAILS_CONFIGURATION = 'SUBJECT_PROFILE_DETAILS_CONFIGURATION',
  SUBJECT_PROTOCOL_DEVIATION = 'SUBJECT_PROTOCOL_DEVIATION',
  SUBJECT_QUERY = 'SUBJECT_QUERY',
  SUBJECT_REVIEW_INSTANCE = 'SUBJECT_REVIEW_INSTANCE',
  SUBJECT_REVIEW_LOGS = 'SUBJECT_REVIEW_LOGS',
  SUBJECT_VISIT = 'SUBJECT_VISIT',
  SYSTEM_ORGANISATION = 'SYSTEM_ORGANISATION',
  TAG = 'TAG',
  TAG_INSTANCE = 'TAG_INSTANCE',
  USERS = 'USERS',
  WIDGET = 'WIDGET'
}

export type AuditSearchConditionInput = {
  field?: AuditSearchField | null | undefined;
  operator?: AuditSearchOperator | null | undefined;
  value?: string | null | undefined;
  value2?: string | null | undefined;
  values?: Array<string | null | undefined> | null | undefined;
};

export enum AuditSearchField {
  AUDIT_ACTION = 'AUDIT_ACTION',
  AUDIT_AREA = 'AUDIT_AREA',
  AUDIT_CREATED = 'AUDIT_CREATED',
  AUDIT_DATA_TYPE = 'AUDIT_DATA_TYPE',
  AUDIT_DESCRIPTION = 'AUDIT_DESCRIPTION',
  AUDIT_REASON = 'AUDIT_REASON',
  AUDIT_RECORD_ID = 'AUDIT_RECORD_ID',
  AUDIT_STUDY_ID = 'AUDIT_STUDY_ID',
  AUDIT_USER_EMAIL = 'AUDIT_USER_EMAIL',
  AUDIT_USER_FIRSTNAME = 'AUDIT_USER_FIRSTNAME',
  AUDIT_USER_ID = 'AUDIT_USER_ID',
  AUDIT_USER_LAST_NAME = 'AUDIT_USER_LAST_NAME'
}

export enum AuditSearchOperator {
  AND = 'AND',
  OR = 'OR'
}

export enum AuditServiceType {
  CENTRAL_MONITORING_2 = 'CENTRAL_MONITORING_2',
  CORE = 'CORE',
  REPORTING = 'REPORTING',
  SUBJECT_MONITORING = 'SUBJECT_MONITORING'
}

export enum Authentication {
  OPRA = 'OPRA',
  SSO = 'SSO'
}

export enum AutomationRange {
  ALL = 'ALL',
  SPECIFIC_RANGE = 'SPECIFIC_RANGE'
}

export type AxisInput = {
  dateSeries?: Array<DateSeriesInput> | null | undefined;
  numericSeries?: Array<NumericSeriesInput> | null | undefined;
  title: string;
  type: TimelineAxisType;
  unit?: string | null | undefined;
};

export type CentralMonitoringObservationActionInput = {
  actionTaken?: string | null | undefined;
  completedDate?: any;
  description?: string | null | undefined;
  expectedCompleteDate?: any;
  id?: any;
  observationId?: any;
  ownerId?: any;
  recordId?: any;
  requestDate?: any;
  result?: string | null | undefined;
  rootCause?: string | null | undefined;
};

export enum CentralMonitoringObservationArea {
  PANEL = 'PANEL',
  RISK_OVERVIEW = 'RISK_OVERVIEW',
  SITE_OVERVIEW = 'SITE_OVERVIEW',
  SITE_SUMMARY = 'SITE_SUMMARY',
  STUDY_OVERVIEW = 'STUDY_OVERVIEW'
}

export type CentralMonitoringObservationInput = {
  closedDate?: any;
  comments?: string | null | undefined;
  confirmedCause?: string | null | undefined;
  dataSetId?: any;
  description?: string | null | undefined;
  id?: any;
  observationDate?: any;
  ownerId?: any;
  panelId?: any;
  potentialCause?: string | null | undefined;
  qtlExceeded?: boolean | null | undefined;
  recordId?: any;
  siteId?: any;
  studyId?: any;
  type?: CentralMonitoringObservationArea | null | undefined;
};

export type CloseCommentInput = {
  entityType: string;
  id: any;
  replySelectors: Array<SelectorData>;
};

export type CommentSelector = {
  id: any;
  replySelectors: Array<SelectorData>;
  version: number;
};

export type CommentsInput = {
  entityType: string;
  parentId: any;
};

export enum ControlHubModelPeriodType {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  NONE = 'NONE',
  QUARTERS = 'QUARTERS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum ControlsAutomationColor {
  LOWER_AMBER_LOWER_RED = 'LOWER_AMBER_LOWER_RED',
  LOWER_RED = 'LOWER_RED',
  NONE = 'NONE',
  UPPER_AMBER_UPPER_RED = 'UPPER_AMBER_UPPER_RED',
  UPPER_RED = 'UPPER_RED',
  UPPER_RED_LOWER_AMBER_LOWER_RED = 'UPPER_RED_LOWER_AMBER_LOWER_RED',
  UPPER_RED_LOWER_RED = 'UPPER_RED_LOWER_RED',
  UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED = 'UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED',
  UPPER_RED_UPPER_AMBER_LOWER_RED = 'UPPER_RED_UPPER_AMBER_LOWER_RED'
}

export type ControlsHubConfigWidgetInputType = {
  displayName?: string | null | undefined;
  fieldKey?: string | null | undefined;
  fieldName?: string | null | undefined;
  iconName?: number | null | undefined;
  id?: any;
  recordId?: any;
  studyId?: any;
  tableCode?: number | null | undefined;
  typeCode?: number | null | undefined;
};

export type CountryInputType = {
  code?: string | null | undefined;
  name?: string | null | undefined;
};

export type CreateCommentInput = {
  content: string;
  entityType: string;
  parentId: any;
};

export type CreateCommentReplyInput = {
  content: string;
  entityType: string;
  parentCommentId: any;
  replySelectors: Array<SelectorData>;
};

export enum CriticalToQualityFactorWidgetType {
  NUMBER_ACTIVE = 'NUMBER_ACTIVE',
  NUMBER_ACTIVE_CRITICAL = 'NUMBER_ACTIVE_CRITICAL',
  NUMBER_ACTIVE_CTQS_WITHOUT_FUNCTIONAL_DATA_REVIEWS = 'NUMBER_ACTIVE_CTQS_WITHOUT_FUNCTIONAL_DATA_REVIEWS',
  NUMBER_ACTIVE_CTQS_WITHOUT_RISKS = 'NUMBER_ACTIVE_CTQS_WITHOUT_RISKS',
  NUMBER_TOTAL = 'NUMBER_TOTAL'
}

export type CriticalVariableInput = {
  active?: boolean | null | undefined;
  controls?: Array<any> | null | undefined;
  dataSource?: string | null | undefined;
  description: string;
  edcEntry?: string | null | undefined;
  edcentryId?: any;
  id?: any;
  internalOnly?: boolean | null | undefined;
  isCritical?: boolean | null | undefined;
  isIsmp?: boolean | null | undefined;
  justification?: string | null | undefined;
  recordId?: any;
  responsibleVendor?: string | null | undefined;
  sourceSystem?: string | null | undefined;
  studyId?: any;
  type?: CriticalVariableType | null | undefined;
  typeId?: any;
  vendorIds?: Array<any> | null | undefined;
};

export enum CriticalVariableType {
  BOTH = 'BOTH',
  DATA = 'DATA',
  NONE = 'NONE',
  PROCESS = 'PROCESS'
}

export type DashboardChildPanelInput = {
  index?: any;
  panelId?: any;
  panelRecordId?: any;
};

export type DashboardDataReviewInput = {
  dataReviewId?: any;
  index?: any;
};

export type DashboardInput = {
  configId?: any;
  panels?: Array<DashboardParentPanelInput | null | undefined> | null | undefined;
  studyId?: any;
  type?: DashboardType | null | undefined;
};

export type DashboardParentPanelInput = {
  childPanels?: Array<DashboardChildPanelInput | null | undefined> | null | undefined;
  dataReviews?: Array<DashboardDataReviewInput | null | undefined> | null | undefined;
  index?: any;
  panelId?: any;
};

export enum DashboardType {
  SITE = 'SITE',
  STUDY = 'STUDY'
}

export type DataListingsListItemInput = {
  datatableId?: any;
  name?: string | null | undefined;
  recordId?: number | null | undefined;
};

export enum DataPopulation {
  ALL = 'ALL',
  MOST_RECENT = 'MOST_RECENT'
}

export type DataReviewTableColumnInput = {
  columnId?: any;
  dataField?: string | null | undefined;
  dataSource?: string | null | undefined;
  denominatorField?: string | null | undefined;
  heading?: string | null | undefined;
  level?: DataReviewTableColumnLevel | null | undefined;
  numeratorField?: string | null | undefined;
  panelField?: PanelFieldType | null | undefined;
  panelId?: any;
  type?: DataReviewTableColumnType | null | undefined;
};

export enum DataReviewTableColumnLevel {
  COUNTRY = 'COUNTRY',
  NONE = 'NONE',
  SITE = 'SITE',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT'
}

export enum DataReviewTableColumnType {
  COUNT = 'COUNT',
  COUNTRY_MEAN = 'COUNTRY_MEAN',
  COUNTRY_MEDIAN = 'COUNTRY_MEDIAN',
  MAX = 'MAX',
  MIN = 'MIN',
  PANEL = 'PANEL',
  PERCENTAGE = 'PERCENTAGE',
  PERCENTILE = 'PERCENTILE',
  RATE = 'RATE',
  SITE_MEAN = 'SITE_MEAN',
  SITE_MEDIAN = 'SITE_MEDIAN',
  STANDARD_CALCULATION = 'STANDARD_CALCULATION',
  STATIC = 'STATIC',
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN',
  SUM = 'SUM'
}

export type DataReviewTableInput = {
  active?: boolean | null | undefined;
  columns?: Array<DataReviewTableColumnInput | null | undefined> | null | undefined;
  configId?: any;
  dataSource?: string | null | undefined;
  description?: string | null | undefined;
  id?: any;
  name?: string | null | undefined;
  recordId?: any;
  studyId?: any;
  type?: DataReviewType | null | undefined;
};

export enum DataReviewType {
  COUNTRY = 'COUNTRY',
  DATA = 'DATA',
  SITE = 'SITE',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT'
}

export enum DataStorageRegion {
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
  OPRA_EU = 'OPRA_EU',
  OPRA_US = 'OPRA_US'
}

export enum DataViewConfigValidation {
  CONFIG_COUNT_MISMATCH = 'CONFIG_COUNT_MISMATCH',
  CONFIG_ID_IN_USE = 'CONFIG_ID_IN_USE',
  FAILED = 'FAILED',
  INVALID_CONFIG_ID = 'INVALID_CONFIG_ID',
  INVALID_DATA_SOURCE = 'INVALID_DATA_SOURCE',
  INVALID_ID = 'INVALID_ID',
  INVALID_NAME = 'INVALID_NAME',
  IN_USE = 'IN_USE',
  MAIN_PANEL_IN_PANELS = 'MAIN_PANEL_IN_PANELS',
  MAIN_PANEL_IN_USE = 'MAIN_PANEL_IN_USE',
  NAME_IN_USE = 'NAME_IN_USE',
  SUCCESS = 'SUCCESS'
}

export type DataViewConfigurationInput = {
  configId?: any;
  dataFilterIds?: Array<any> | null | undefined;
  dataSource?: RowDataSourceTable | null | undefined;
  dataTableIds?: Array<any> | null | undefined;
  displayIndex?: number | null | undefined;
  id?: any;
  isActive?: boolean | null | undefined;
  mainPanelId?: any;
  name?: string | null | undefined;
  panelIds?: Array<any> | null | undefined;
  recordId?: any;
  studyId?: any;
  unfilterablePanelIds?: Array<any> | null | undefined;
};

export type DataViewFilterInput = {
  configId?: any;
  dataSource?: RowDataSourceTable | null | undefined;
  displayIndex?: number | null | undefined;
  fieldKey?: string | null | undefined;
  fieldName?: string | null | undefined;
  id?: any;
  isDefault?: boolean | null | undefined;
  label?: string | null | undefined;
  recordId?: any;
  studyId?: any;
};

export enum DataViewFilterValidation {
  CANT_DELETE_NON_REMOVABLE_FIELD_KEY = 'CANT_DELETE_NON_REMOVABLE_FIELD_KEY',
  CANT_UPDATE_DEFAULT_FIELD_KEY = 'CANT_UPDATE_DEFAULT_FIELD_KEY',
  CANT_UPDATE_NON_REMOVABLE_FIELD_KEY = 'CANT_UPDATE_NON_REMOVABLE_FIELD_KEY',
  FAILED = 'FAILED',
  FIELD_IN_USE = 'FIELD_IN_USE',
  FILTER_COUNT_MISMATCH = 'FILTER_COUNT_MISMATCH',
  INVALID_DATA_SOURCE = 'INVALID_DATA_SOURCE',
  INVALID_FILTER_ID = 'INVALID_FILTER_ID',
  LABEL_IN_USE = 'LABEL_IN_USE',
  SUCCESS = 'SUCCESS',
  UNKNOWN_ID = 'UNKNOWN_ID'
}

export type DateSeriesInput = {
  endField?: string | null | undefined;
  id?: any;
  label: string;
  plotLabel: string;
  rowData: SeriesRowDataInput;
  startField: string;
  type: TimelineDateSeriesType;
};

export type DeleteCommentInput = {
  entityType: string;
  id: any;
};

export type DeleteCommentReplyInput = {
  entityType: string;
  id: any;
  replySelectors: Array<SelectorData>;
};

export enum EventRatesOTBenchmarkType {
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum EventRatesOTCountryBenchmarkType {
  COUNTRY_RATE = 'COUNTRY_RATE',
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum EventRatesOTThresholdType {
  FIXED = 'FIXED',
  LANEY_U_CHART = 'LANEY_U_CHART',
  QUASI_POISSON_U_CHART = 'QUASI_POISSON_U_CHART',
  U_CHART = 'U_CHART'
}

export type EventRatesOverTimeInput = {
  automationRange?: AutomationRange | null | undefined;
  benchmarkType?: EventRatesOTBenchmarkType | null | undefined;
  calcEndDates?: Array<string | null | undefined> | null | undefined;
  calcStartDate?: string | null | undefined;
  countryBenchmark?: EventRatesOTCountryBenchmarkType | null | undefined;
  cumulativeOrTimePeriod?: ModelPlotCalculation | null | undefined;
  denominatorName?: string | null | undefined;
  eventName?: string | null | undefined;
  expectedVolume?: number | null | undefined;
  lowerAmber?: number | null | undefined;
  lowerRed?: number | null | undefined;
  minSubjects?: number | null | undefined;
  minTimeOnStudyPeriod?: ControlHubModelPeriodType | null | undefined;
  minTimeOnStudyUnit?: number | null | undefined;
  numberOfTimePeriods?: number | null | undefined;
  numeratorName?: string | null | undefined;
  plotBy?: ModelPlotBy | null | undefined;
  qtl?: boolean | null | undefined;
  reportOutOfTolerance?: boolean | null | undefined;
  rowData?: string | null | undefined;
  rowDataDate?: string | null | undefined;
  scaleBy?: ModelScaleBy | null | undefined;
  studySpecificBenchmark?: number | null | undefined;
  thresholdType?: EventRatesOTThresholdType | null | undefined;
  timepointDate?: string | null | undefined;
  timepointsList?: string | null | undefined;
  upperAmber?: number | null | undefined;
  upperRed?: number | null | undefined;
  xAxisPtsToShade?: number | null | undefined;
  xAxisTitle?: string | null | undefined;
  yAxisTitle?: string | null | undefined;
};

export enum EventType {
  EMAIL_SENT = 'EMAIL_SENT',
  LOGIN = 'LOGIN',
  LOGIN_ACCOUNT_DISABLED = 'LOGIN_ACCOUNT_DISABLED',
  LOGIN_ACCOUNT_INACTIVE = 'LOGIN_ACCOUNT_INACTIVE',
  LOGIN_ACCOUNT_LOCKED = 'LOGIN_ACCOUNT_LOCKED',
  LOGIN_INCORRECT_2_FA = 'LOGIN_INCORRECT_2_FA',
  LOGIN_INCORRECT_PASSWORD = 'LOGIN_INCORRECT_PASSWORD',
  LOGIN_SSO = 'LOGIN_SSO',
  LOGIN_SSO_INACTIVE_ORG_MEMBER = 'LOGIN_SSO_INACTIVE_ORG_MEMBER',
  LOGIN_SSO_NO_USER_INFO = 'LOGIN_SSO_NO_USER_INFO',
  LOGIN_SSO_UNKNOWN_ORG_MEMBER = 'LOGIN_SSO_UNKNOWN_ORG_MEMBER',
  LOGIN_SSO_USER_CREATED = 'LOGIN_SSO_USER_CREATED',
  LOGIN_UNKNOWN_EMAIL = 'LOGIN_UNKNOWN_EMAIL',
  LOGOUT = 'LOGOUT',
  SMS_SENT = 'SMS_SENT'
}

export type ExtraDataFieldInput = {
  active?: boolean | null | undefined;
  configId?: any;
  fieldType?: FieldDefinitionFieldType | null | undefined;
  friendlyName?: string | null | undefined;
  id?: any;
  isCalculated?: boolean | null | undefined;
  recordId?: any;
  sourceFieldName?: string | null | undefined;
  studyId?: any;
  table?: RowDataSourceTable | null | undefined;
};

export enum FieldDefinitionFieldType {
  BOOL = 'BOOL',
  DATE = 'DATE',
  FLOAT = 'FLOAT',
  INT = 'INT',
  PARTIAL_DATE = 'PARTIAL_DATE',
  TEXT = 'TEXT'
}

export enum FieldTag {
  SUBJECT_POPULATION = 'SUBJECT_POPULATION'
}

export type FunctionalDataReviewInput = {
  active?: boolean | null | undefined;
  comment?: string | null | undefined;
  criticalToQualityFactorId?: any;
  description?: string | null | undefined;
  id?: any;
  libraryReferenceId?: any;
  responsibleFunctionId?: any;
  studyId?: any;
};

export enum Gender {
  F = 'F',
  M = 'M',
  NONE = 'NONE'
}

export enum ImportAction {
  FAILED_TO_GENERATE_FIELDS = 'FAILED_TO_GENERATE_FIELDS',
  FAILED_TO_PROCESS_PANELS = 'FAILED_TO_PROCESS_PANELS',
  FINISH_GENERATE_FIELDS = 'FINISH_GENERATE_FIELDS',
  FINISH_IMPORT_DATA = 'FINISH_IMPORT_DATA',
  FINISH_PROCESS_PANELS = 'FINISH_PROCESS_PANELS',
  ROLLBACK_GENERATE_FIELDS = 'ROLLBACK_GENERATE_FIELDS',
  ROLLBACK_IMPORT = 'ROLLBACK_IMPORT',
  ROLLBACK_PROCESS_PANELS = 'ROLLBACK_PROCESS_PANELS',
  START_IMPORT_DATA = 'START_IMPORT_DATA'
}

export enum ImportCurrentState {
  COMPLETE = 'COMPLETE',
  DATA_IMPORTED = 'DATA_IMPORTED',
  FIELDS_GENERATED = 'FIELDS_GENERATED',
  IMPORTING_DATA = 'IMPORTING_DATA',
  ROLLED_BACK = 'ROLLED_BACK'
}

export type KeyValueInput = {
  key?: string | null | undefined;
  value?: string | null | undefined;
};

export type LibraryControlInput = {
  action?: string | null | undefined;
  active?: boolean | null | undefined;
  controlPhaseId?: any;
  controlTypeId?: any;
  description?: string | null | undefined;
  id?: any;
  organisationId?: any;
  phase?: PhaseType | null | undefined;
  recordId?: any;
  responsibleFunctionId?: any;
  reviewFrequencyPeriod?: any;
  reviewFrequencyUnits?: TimeFrequencyType | null | undefined;
  studyId?: any;
  systemReferenceId?: any;
  threshold?: string | null | undefined;
  typeId?: any;
  userId?: any;
};

export type LibraryFunctionalDataReviewInput = {
  active?: boolean | null | undefined;
  description?: string | null | undefined;
  id?: any;
  responsibleFunctionId?: any;
};

export type LibraryRiskDisplayOrderInputType = {
  displayOrder?: number | null | undefined;
  libraryRiskId?: any;
};

export type LibraryRiskInput = {
  active?: boolean | null | undefined;
  controlStrategyId?: any;
  countries?: Array<CountryInputType | null | undefined> | null | undefined;
  displayOrder?: any;
  id?: any;
  libraryControlIds?: Array<any> | null | undefined;
  organisationId?: any;
  recordId?: any;
  responsibleFunctionId?: any;
  reviewFrequencyPeriod?: number | null | undefined;
  reviewFrequencyUnits?: TimeFrequencyType | null | undefined;
  reviewRequired?: boolean | null | undefined;
  riskCategoryId?: any;
  riskLibraryCategoryIds?: Array<any> | null | undefined;
  statement?: string | null | undefined;
  studyId?: any;
  systemReferenceId?: any;
  userId?: any;
  vendorIds?: Array<any> | null | undefined;
};

export enum ModelPlotBy {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum ModelPlotCalculation {
  BY_TIME_PERIOD = 'BY_TIME_PERIOD',
  CUMULATIVE = 'CUMULATIVE'
}

export enum ModelScaleBy {
  NONE = 'NONE',
  PER_10_SUBJECT_TIME_POINTS = 'PER_10_SUBJECT_TIME_POINTS',
  PER_10_SUBJECT_YEARS = 'PER_10_SUBJECT_YEARS',
  PER_100_SUBJECT_TIME_POINTS = 'PER_100_SUBJECT_TIME_POINTS',
  PER_100_SUBJECT_YEARS = 'PER_100_SUBJECT_YEARS',
  PER_1000_SUBJECT_TIME_POINTS = 'PER_1000_SUBJECT_TIME_POINTS',
  PER_1000_SUBJECT_YEARS = 'PER_1000_SUBJECT_YEARS',
  PER_SUBJECT_MONTH = 'PER_SUBJECT_MONTH',
  PER_SUBJECT_TIME_POINT = 'PER_SUBJECT_TIME_POINT',
  PER_SUBJECT_WEEK = 'PER_SUBJECT_WEEK',
  PER_SUBJECT_YEAR = 'PER_SUBJECT_YEAR',
  _1 = '_1',
  _10 = '_10',
  _100 = '_100',
  _1000 = '_1000'
}

export enum NamedItemType {
  CONTROLS_REVIEW_LOG_DECISION = 'CONTROLS_REVIEW_LOG_DECISION',
  CONTROL_PHASE = 'CONTROL_PHASE',
  CONTROL_TYPE = 'CONTROL_TYPE',
  CTQEDC_ENTRY = 'CTQEDC_ENTRY',
  CTQ_TYPE = 'CTQ_TYPE',
  DETECTION_TYPE = 'DETECTION_TYPE',
  RESPONSIBLE_FUNCTION = 'RESPONSIBLE_FUNCTION',
  REVIEW_LOG_DECISION = 'REVIEW_LOG_DECISION',
  RISK_CATEGORY = 'RISK_CATEGORY',
  RISK_CONTROL_STRATEGY = 'RISK_CONTROL_STRATEGY',
  RISK_LIBRARY_CATEGORY = 'RISK_LIBRARY_CATEGORY',
  RISK_OBSERVATION_CLASSIFICATION = 'RISK_OBSERVATION_CLASSIFICATION',
  RISK_QUALITY_ISSUE = 'RISK_QUALITY_ISSUE',
  SM_REVIEW_LOG_DECISION = 'SM_REVIEW_LOG_DECISION',
  /** @deprecated This is no longer in use */
  SM_REVIEW_TYPE = 'SM_REVIEW_TYPE',
  VENDOR = 'VENDOR'
}

export type NullablePartialDateTimeInput = {
  ignore?: any;
  time?: any;
};

export type NumericSeriesInput = {
  dateField: string;
  id?: any;
  label: string;
  rowData: SeriesRowDataInput;
  threshold?: NumericThresholdInput | null | undefined;
  type: TimelineNumericSeriesType;
  yPlotField: string;
};

export type NumericThresholdFieldInput = {
  lower?: string | null | undefined;
  upper?: string | null | undefined;
};

export type NumericThresholdInput = {
  field?: NumericThresholdFieldInput | null | undefined;
  value?: NumericThresholdValueInput | null | undefined;
};

export type NumericThresholdValueInput = {
  lower?: number | null | undefined;
  upper?: number | null | undefined;
};

export type OpenCommentInput = {
  entityType: string;
  id: any;
  replySelectors: Array<SelectorData>;
};

export type OrganisationContactInput = {
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  mobile?: string | null | undefined;
  phone?: string | null | undefined;
};

export type OrganisationIndicationInput = {
  id?: any;
  name?: string | null | undefined;
  recordId?: any;
};

export enum OrganisationMemberStatus {
  INVITED = 'INVITED',
  JOINED = 'JOINED',
  VERIFYING = 'VERIFYING'
}

export type OrganisationProductInput = {
  activeIngredients?: string | null | undefined;
  code?: string | null | undefined;
  id?: any;
  name?: string | null | undefined;
  recordId?: any;
  referenceNumber?: string | null | undefined;
  registrationNumber?: string | null | undefined;
};

export type OrganisationProgramInput = {
  id?: any;
  indicationIds?: Array<any> | null | undefined;
  name?: string | null | undefined;
  productIds?: Array<any> | null | undefined;
  recordId?: any;
};

export type OrganisationRoleInput = {
  active?: boolean | null | undefined;
  description?: string | null | undefined;
  id?: any;
  modules?: Array<string | null | undefined> | null | undefined;
  name?: string | null | undefined;
  organisationId?: any;
  recordId?: any;
  rights?: Array<OrganisationRoleRightInput | null | undefined> | null | undefined;
};

export type OrganisationRoleRightInput = {
  active?: boolean | null | undefined;
  element?: string | null | undefined;
  moduleId?: any;
  permissions?: any;
};

export type OrganisationSecurityInput = {
  accountInactiveDays?: any;
  authenticationMethod?: Authentication | null | undefined;
  lockoutPeriodMinutes?: any;
  minLowercaseCount?: any;
  minNumberCount?: any;
  minPasswordLength?: any;
  minSpecialCharCount?: any;
  minUppercaseCount?: any;
  numAttemptsBeforeLockout?: any;
  ssoIssuer?: string | null | undefined;
  twoFactorEnabled?: boolean | null | undefined;
  userIdleTimeoutMinutes?: any;
};

export enum OrganisationType {
  CRO = 'CRO',
  NONE = 'NONE',
  SPONSOR = 'SPONSOR'
}

export enum OverviewColumnConfigurationEnumType {
  CALCULATED = 'CALCULATED',
  OVERVIEW = 'OVERVIEW',
  STATIC = 'STATIC'
}

export enum OverviewRowOrderConfigurationEnumType {
  RED_DECISION_KR_IS_DESC = 'RED_DECISION_KR_IS_DESC',
  RED_KR_IS_DESC = 'RED_KR_IS_DESC',
  SITE_NAME_ASC = 'SITE_NAME_ASC',
  SITE_NAME_DESC = 'SITE_NAME_DESC',
  SITE_SCORE_DESC = 'SITE_SCORE_DESC'
}

export enum PanelAggregate {
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN'
}

export type PanelAndDataViewInput = {
  dataViewRef?: any;
  panelRef: any;
};

export enum PanelAverageLineThresholdType {
  STUDY_MEDIAN_MEAN = 'STUDY_MEDIAN_MEAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum PanelBenchmark {
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum PanelColumnRangeCategory {
  DATE = 'DATE',
  NUMBER = 'NUMBER'
}

export enum PanelColumnType {
  RANGED = 'RANGED',
  STANDARD = 'STANDARD'
}

export type PanelDataSourceInput = {
  countField?: string | null | undefined;
  countFirstEventTypeOnly?: boolean | null | undefined;
  dataSource?: string | null | undefined;
  dateField?: string | null | undefined;
  flagField?: string | null | undefined;
  rateByField?: string | null | undefined;
  rateByType?: PanelRateByType | null | undefined;
  sortField?: string | null | undefined;
  timePeriod?: PanelTimePeriod | null | undefined;
  useEarliestEndDate?: boolean | null | undefined;
  xAxisDataField?: string | null | undefined;
  xAxisEndDateFields?: Array<string | null | undefined> | null | undefined;
  yAxisDataField?: string | null | undefined;
};

export enum PanelDisplayBy {
  COUNTRY = 'COUNTRY',
  EVENT = 'EVENT',
  SITE = 'SITE',
  SUBJECT = 'SUBJECT'
}

export enum PanelDisplayUnits {
  COUNT = 'COUNT',
  PERCENT = 'PERCENT',
  PERCENT_BY_POPULATION = 'PERCENT_BY_POPULATION'
}

export enum PanelFieldType {
  COUNTRY_SITE_MEAN = 'COUNTRY_SITE_MEAN',
  SITE_RATE = 'SITE_RATE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SITE_MEAN = 'STUDY_SITE_MEAN'
}

export enum PanelGraphCategoryClause {
  EQUAL = 'EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
  MORE_THAN = 'MORE_THAN',
  MORE_THAN_EQUAL = 'MORE_THAN_EQUAL',
  NONE = 'NONE'
}

export type PanelGraphCategoryInput = {
  clause?: PanelGraphCategoryClause | null | undefined;
  index: any;
  max?: any;
  min?: any;
};

export type PanelGraphInput = {
  categories?: Array<PanelGraphCategoryInput | null | undefined> | null | undefined;
  categoryRangePeriod?: PanelTimePeriod | null | undefined;
  categoryRangeUnit?: any;
  columnRangeCategory?: PanelColumnRangeCategory | null | undefined;
  columnType?: PanelColumnType | null | undefined;
  dataInclusionPeriod?: PanelTimePeriod | null | undefined;
  dataInclusionUnit?: any;
  displayBy?: PanelDisplayBy | null | undefined;
  displayUnits?: PanelDisplayUnits | null | undefined;
  hideStudyColumns?: boolean | null | undefined;
  lineCalculation?: PanelLineCalculation | null | undefined;
  lineThresholdType?: PanelAverageLineThresholdType | null | undefined;
  numberOfSeries?: any;
  orderBy?: PanelOrderBy | null | undefined;
  plotThreshold?: any;
  plotTitle?: string | null | undefined;
  series?: Array<PanelGraphSeriesInput | null | undefined> | null | undefined;
  seriesType?: PanelSeriesType | null | undefined;
  thresholdNum1?: any;
  thresholdNum2?: any;
  timePeriod?: PanelLineTimePeriod | null | undefined;
  type?: PanelGraphType | null | undefined;
  xTitle?: string | null | undefined;
  yTitle?: string | null | undefined;
};

export type PanelGraphSeriesInput = {
  dataPointField?: string | null | undefined;
  dataSource?: string | null | undefined;
  dateField?: string | null | undefined;
  label?: string | null | undefined;
  threshold?: any;
};

export enum PanelGraphType {
  COLUMN = 'COLUMN',
  DONUT = 'DONUT',
  HEATMAP = 'HEATMAP',
  RADIAL = 'RADIAL',
  SANKEY = 'SANKEY',
  SCATTER_PLOT_LINE = 'SCATTER_PLOT_LINE',
  STACKED_COLUMN = 'STACKED_COLUMN'
}

export type PanelInput = {
  active?: boolean | null | undefined;
  associatedRisks?: Array<any> | null | undefined;
  configId?: any;
  dataSource?: PanelDataSourceInput | null | undefined;
  decision?: boolean | null | undefined;
  description?: string | null | undefined;
  eventRatesOverTimeParameters?: EventRatesOverTimeInput | null | undefined;
  graph?: PanelGraphInput | null | undefined;
  id?: any;
  includeInSiteScoring?: boolean | null | undefined;
  modelParams?: PanelModelParamsInput | null | undefined;
  name?: string | null | undefined;
  organisationId?: any;
  panelTheme?: PanelTheme | null | undefined;
  panelType?: PanelType | null | undefined;
  proportionsOverTimeParameters?: ProportionsOverTimeInput | null | undefined;
  recordId?: any;
  scheduleId?: any;
  studyId?: any;
  studyOverviewExtraColumns?: Array<StudyOverviewExtraColumnInput | null | undefined> | null | undefined;
  timeline?: TimelineInput | null | undefined;
  triOpDateParameters?: TriOpDateParametersInput | null | undefined;
  weight?: any;
  yAxisColumnValue?: string | null | undefined;
};

export enum PanelIntervalType {
  APPROXIMATE = 'APPROXIMATE',
  EXACT = 'EXACT'
}

export enum PanelLineCalculation {
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN'
}

export enum PanelLineTimePeriod {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export type PanelModelParamsInput = {
  amberCutoff?: any;
  amberMaxScore?: any;
  benchmarkType?: PanelBenchmark | null | undefined;
  benchmarkValue?: any;
  confidenceIntervalType?: PanelIntervalType | null | undefined;
  dataInclusionPeriod?: PanelTimePeriod | null | undefined;
  dataInclusionUnit?: any;
  greenMaxScore?: any;
  hideLower?: boolean | null | undefined;
  hideUpper?: boolean | null | undefined;
  lowerAmber?: any;
  lowerBigRed?: any;
  lowerRed?: any;
  minimumDataMovementScore?: any;
  plotBy?: PanelPlotBy | null | undefined;
  rateBy?: PanelRateBy | null | undefined;
  rateGroupType?: RateGroupType | null | undefined;
  redCutoff?: any;
  siteScoring?: PanelSiteScoring | null | undefined;
  stableValue?: any;
  stableVariableType?: string | null | undefined;
  studyComparison?: PanelAggregate | null | undefined;
  thresholdNum1?: any;
  thresholdNum2?: any;
  triThreshold1Type?: PanelThresholdType | null | undefined;
  triThreshold2Type?: PanelThresholdType | null | undefined;
  type?: PanelModelType | null | undefined;
  unitMultiplier?: any;
  upperAmber?: any;
  upperBigRed?: any;
  upperRed?: any;
};

export enum PanelModelType {
  FUNNEL = 'FUNNEL',
  FUNNEL_TREND = 'FUNNEL_TREND',
  RATE_GROUP = 'RATE_GROUP',
  RATE_GROUP_TREND = 'RATE_GROUP_TREND',
  TRI_OPERATIONAL = 'TRI_OPERATIONAL',
  TRI_OPERATIONAL_TREND = 'TRI_OPERATIONAL_TREND'
}

export enum PanelOrderBy {
  LABEL_ASCENDING = 'LABEL_ASCENDING',
  LABEL_DESCENDING = 'LABEL_DESCENDING',
  LABEL_VISIT_SEQUENCE_NUMBER = 'LABEL_VISIT_SEQUENCE_NUMBER',
  VOLUME_ASCENDING = 'VOLUME_ASCENDING',
  VOLUME_BELL_CURVE = 'VOLUME_BELL_CURVE',
  VOLUME_DESCENDING = 'VOLUME_DESCENDING'
}

export enum PanelPlotBy {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum PanelRateBy {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum PanelRateByType {
  COUNT = 'COUNT',
  TIME_PERIOD = 'TIME_PERIOD'
}

export enum PanelSeriesType {
  EVENT = 'EVENT',
  SITE = 'SITE',
  SITE_AVERAGE = 'SITE_AVERAGE',
  SITE_CUMULATIVE = 'SITE_CUMULATIVE',
  SUBJECT = 'SUBJECT',
  SUBJECT_BY_VISIT = 'SUBJECT_BY_VISIT'
}

export enum PanelSiteScoring {
  HIGHER_GREEN = 'HIGHER_GREEN',
  HIGHER_PURPLE = 'HIGHER_PURPLE',
  LOWER_GREEN = 'LOWER_GREEN',
  LOWER_PURPLE = 'LOWER_PURPLE',
  STANDARD = 'STANDARD'
}

export enum PanelTheme {
  NONE = 'NONE',
  THEME_1 = 'THEME_1',
  THEME_2 = 'THEME_2',
  THEME_3 = 'THEME_3',
  THEME_4 = 'THEME_4'
}

export enum PanelThresholdType {
  SAMPLE_MEAN = 'SAMPLE_MEAN',
  SAMPLE_MEDIAN = 'SAMPLE_MEDIAN',
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum PanelTimePeriod {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  QUARTERS = 'QUARTERS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum PanelType {
  EVENT_RATES_OVER_TIME = 'EVENT_RATES_OVER_TIME',
  GRAPH = 'GRAPH',
  MODEL = 'MODEL',
  PROPORTIONS_OVER_TIME = 'PROPORTIONS_OVER_TIME',
  TIMELINE = 'TIMELINE',
  TRI_OP_DATE = 'TRI_OP_DATE'
}

export enum PhaseType {
  DETECTION = 'DETECTION',
  PRE_STUDY = 'PRE_STUDY',
  RESULTS_REPORTING = 'RESULTS_REPORTING',
  STUDY_CONDUCT = 'STUDY_CONDUCT'
}

export enum ProportionsOTBenchmarkType {
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SITE_MEAN = 'STUDY_SITE_MEAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum ProportionsOTCountryBenchmarkType {
  COUNTRY_RATE = 'COUNTRY_RATE',
  COUNTRY_SITE_MEAN = 'COUNTRY_SITE_MEAN',
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SITE_MEAN = 'STUDY_SITE_MEAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum ProportionsOTThresholdType {
  FIXED = 'FIXED',
  LANEY_P_CHART = 'LANEY_P_CHART',
  P_CHART = 'P_CHART',
  QUASI_BINOMIAL_P_CHART = 'QUASI_BINOMIAL_P_CHART'
}

export type ProportionsOverTimeInput = {
  automationRange?: AutomationRange | null | undefined;
  benchmarkType?: ProportionsOTBenchmarkType | null | undefined;
  countryBenchmark?: ProportionsOTCountryBenchmarkType | null | undefined;
  cumulativeOrTimePeriod?: ModelPlotCalculation | null | undefined;
  denominatorName?: string | null | undefined;
  eligibilityPeriod?: ControlHubModelPeriodType | null | undefined;
  eligibilityUnit?: number | null | undefined;
  expectedVolume?: number | null | undefined;
  lowerAmber?: number | null | undefined;
  lowerRed?: number | null | undefined;
  minData?: number | null | undefined;
  numberOfTimePeriods?: number | null | undefined;
  numeratorName?: string | null | undefined;
  plotBy?: ModelPlotBy | null | undefined;
  qtl?: boolean | null | undefined;
  reportOutOfTolerance?: boolean | null | undefined;
  rowData?: string | null | undefined;
  rowDataDate?: string | null | undefined;
  rowDataFlag?: string | null | undefined;
  scaleBy?: ModelScaleBy | null | undefined;
  studySpecificBenchmark?: number | null | undefined;
  thresholdType?: ProportionsOTThresholdType | null | undefined;
  upperAmber?: number | null | undefined;
  upperRed?: number | null | undefined;
  xAxisPtsToShade?: number | null | undefined;
  xAxisTitle?: string | null | undefined;
  yAxisTitle?: string | null | undefined;
};

export enum RAGColourType {
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  RED = 'RED'
}

export type RAGInput = {
  colour?: RAGColourType | null | undefined;
  x?: any;
  y?: any;
};

export enum RateGroupType {
  NEGATIVE_BINOMIAL = 'NEGATIVE_BINOMIAL',
  POISSON = 'POISSON'
}

export type ReportDefinitionColumnInput = {
  dataField?: ReportDefinitionFieldTypes | null | undefined;
  index?: any;
};

export enum ReportDefinitionFieldTypes {
  ACT_COMMENTS = 'ACT_COMMENTS',
  ACT_COMPLETED_DATE = 'ACT_COMPLETED_DATE',
  ACT_DESCRIPTION = 'ACT_DESCRIPTION',
  ACT_EXPECTED_COMPLETION_DATE = 'ACT_EXPECTED_COMPLETION_DATE',
  ACT_ID = 'ACT_ID',
  ACT_OBS = 'ACT_OBS',
  ACT_OBS_ID = 'ACT_OBS_ID',
  ACT_OWNER = 'ACT_OWNER',
  ACT_REQUESTED_DATE = 'ACT_REQUESTED_DATE',
  ACT_RESPONSIBLE_FUNCTION = 'ACT_RESPONSIBLE_FUNCTION',
  ACT_RESULT = 'ACT_RESULT',
  ACT_TYPE = 'ACT_TYPE',
  CM_CONTROLS_HUB_CHART_ASSOCIATED_RISKS = 'CM_CONTROLS_HUB_CHART_ASSOCIATED_RISKS',
  CM_CONTROLS_HUB_CHART_BENCHMARK = 'CM_CONTROLS_HUB_CHART_BENCHMARK',
  CM_CONTROLS_HUB_CHART_DATASET = 'CM_CONTROLS_HUB_CHART_DATASET',
  CM_CONTROLS_HUB_CHART_LOWER_AMBER = 'CM_CONTROLS_HUB_CHART_LOWER_AMBER',
  CM_CONTROLS_HUB_CHART_LOWER_RED = 'CM_CONTROLS_HUB_CHART_LOWER_RED',
  CM_CONTROLS_HUB_CHART_OOT_VALUE = 'CM_CONTROLS_HUB_CHART_OOT_VALUE',
  CM_CONTROLS_HUB_CHART_PLOT_TITLE = 'CM_CONTROLS_HUB_CHART_PLOT_TITLE',
  CM_CONTROLS_HUB_CHART_STATUS = 'CM_CONTROLS_HUB_CHART_STATUS',
  CM_CONTROLS_HUB_CHART_TIME_PERIOD = 'CM_CONTROLS_HUB_CHART_TIME_PERIOD',
  CM_CONTROLS_HUB_CHART_UPPER_AMBER = 'CM_CONTROLS_HUB_CHART_UPPER_AMBER',
  CM_CONTROLS_HUB_CHART_UPPER_RED = 'CM_CONTROLS_HUB_CHART_UPPER_RED',
  CM_CONTROLS_HUB_CHART_Y_AXIS_LABEL = 'CM_CONTROLS_HUB_CHART_Y_AXIS_LABEL',
  CONT_ACTION_TO_BE_TAKEN = 'CONT_ACTION_TO_BE_TAKEN',
  CONT_ACTIVE_DATE = 'CONT_ACTIVE_DATE',
  CONT_ADDITIONAL_INFORMATION = 'CONT_ADDITIONAL_INFORMATION',
  CONT_DATE_IDENTIFIED = 'CONT_DATE_IDENTIFIED',
  CONT_DESCRIPTION = 'CONT_DESCRIPTION',
  CONT_ID = 'CONT_ID',
  CONT_INACTIVATE_DATE = 'CONT_INACTIVATE_DATE',
  CONT_MONITORING_PURPOSE = 'CONT_MONITORING_PURPOSE',
  CONT_MONITORING_VOLUME = 'CONT_MONITORING_VOLUME',
  CONT_OWNER = 'CONT_OWNER',
  CONT_PHASE = 'CONT_PHASE',
  CONT_RESPONSIBLE_FUNCTION = 'CONT_RESPONSIBLE_FUNCTION',
  CONT_REVIEW_FREQUENCY_PERIOD = 'CONT_REVIEW_FREQUENCY_PERIOD',
  CONT_REVIEW_FREQUENCY_UNITS = 'CONT_REVIEW_FREQUENCY_UNITS',
  CONT_THRESHOLD = 'CONT_THRESHOLD',
  CONT_TYPE = 'CONT_TYPE',
  CVEDC_ENTRY = 'CVEDC_ENTRY',
  CVFDR_COUNT = 'CVFDR_COUNT',
  CVID = 'CVID',
  CVISMP = 'CVISMP',
  CV_ACTIVE = 'CV_ACTIVE',
  CV_CRITICAL = 'CV_CRITICAL',
  CV_DATA_SOURCE = 'CV_DATA_SOURCE',
  CV_DESCRIPTION = 'CV_DESCRIPTION',
  CV_JUSTIFICATION = 'CV_JUSTIFICATION',
  CV_OPEN_COMMENTS_COUNT = 'CV_OPEN_COMMENTS_COUNT',
  CV_RESPONSIBLE_VENDOR = 'CV_RESPONSIBLE_VENDOR',
  CV_RISK_COUNT = 'CV_RISK_COUNT',
  CV_SYSTEM = 'CV_SYSTEM',
  CV_TYPE = 'CV_TYPE',
  FDR_COMMENT = 'FDR_COMMENT',
  FDR_DESCRIPTION = 'FDR_DESCRIPTION',
  FDR_ID = 'FDR_ID',
  FDR_RESPONSIBLE_FUNCTION = 'FDR_RESPONSIBLE_FUNCTION',
  OBS_CLASSIFICATION = 'OBS_CLASSIFICATION',
  OBS_CLOSED_DATE = 'OBS_CLOSED_DATE',
  OBS_COMMENTS = 'OBS_COMMENTS',
  OBS_CONFIRMED_CAUSE = 'OBS_CONFIRMED_CAUSE',
  OBS_COUNTRIES = 'OBS_COUNTRIES',
  OBS_ID = 'OBS_ID',
  OBS_OBSERVATION = 'OBS_OBSERVATION',
  OBS_OBSERVATION_DATE = 'OBS_OBSERVATION_DATE',
  OBS_OWNER = 'OBS_OWNER',
  OBS_POTENTIAL_CAUSE = 'OBS_POTENTIAL_CAUSE',
  OBS_RESOLUTION = 'OBS_RESOLUTION',
  OBS_RESPONSIBLE_FUNCTION = 'OBS_RESPONSIBLE_FUNCTION',
  OBS_RISK_ID = 'OBS_RISK_ID',
  OBS_RISK_STATEMENT = 'OBS_RISK_STATEMENT',
  OBS_VENDORS = 'OBS_VENDORS',
  RISK_CATEGORY = 'RISK_CATEGORY',
  RISK_CLOSED_DATE = 'RISK_CLOSED_DATE',
  RISK_CONTROL_STRATEGY = 'RISK_CONTROL_STRATEGY',
  RISK_COUNTRIES = 'RISK_COUNTRIES',
  RISK_DATE_IDENTIFIED = 'RISK_DATE_IDENTIFIED',
  RISK_DETECTABILITY = 'RISK_DETECTABILITY',
  RISK_ID = 'RISK_ID',
  RISK_IMPACT = 'RISK_IMPACT',
  RISK_INTERNAL = 'RISK_INTERNAL',
  RISK_JUSTIFICATION = 'RISK_JUSTIFICATION',
  RISK_LAST_REVIEW_DATE = 'RISK_LAST_REVIEW_DATE',
  RISK_LIKELIHOOD = 'RISK_LIKELIHOOD',
  RISK_LINKED_CM_CONTROLS_COUNT = 'RISK_LINKED_CM_CONTROLS_COUNT',
  RISK_NEXT_REVIEW_DATE = 'RISK_NEXT_REVIEW_DATE',
  RISK_OPEN_COMMENTS_COUNT = 'RISK_OPEN_COMMENTS_COUNT',
  RISK_OUT_OF_TOLERANCE = 'RISK_OUT_OF_TOLERANCE',
  RISK_OWNER = 'RISK_OWNER',
  RISK_QUALITY_ISSUE = 'RISK_QUALITY_ISSUE',
  RISK_QUALITY_ISSUE_REFERENCE = 'RISK_QUALITY_ISSUE_REFERENCE',
  RISK_RAG = 'RISK_RAG',
  RISK_RATIONALE = 'RISK_RATIONALE',
  RISK_RESPONSIBLE_FUNCTION = 'RISK_RESPONSIBLE_FUNCTION',
  RISK_REVIEW_FREQUENCY_PERIOD = 'RISK_REVIEW_FREQUENCY_PERIOD',
  RISK_REVIEW_FREQUENCY_UNIT = 'RISK_REVIEW_FREQUENCY_UNIT',
  RISK_REVIEW_REQUIRED = 'RISK_REVIEW_REQUIRED',
  RISK_REVIEW_STATUS = 'RISK_REVIEW_STATUS',
  RISK_SCORE = 'RISK_SCORE',
  RISK_STATEMENT = 'RISK_STATEMENT',
  RISK_STATUS = 'RISK_STATUS',
  RISK_VENDORS = 'RISK_VENDORS'
}

export type ReportDefinitionInput = {
  description?: string | null | undefined;
  id?: any;
  includeDraftRisks?: boolean | null | undefined;
  includeInternalRisks?: boolean | null | undefined;
  includeNotApplicableRisks?: boolean | null | undefined;
  includeObsoleteRisks?: boolean | null | undefined;
  name?: string | null | undefined;
  recordId?: any;
  tabs?: Array<ReportDefinitionTabInput | null | undefined> | null | undefined;
  userId?: any;
};

export type ReportDefinitionTabInput = {
  columns?: Array<ReportDefinitionColumnInput | null | undefined> | null | undefined;
  tabType?: ReportDefinitionTabs | null | undefined;
};

export enum ReportDefinitionTabs {
  ACTIONS = 'ACTIONS',
  CONTROLS = 'CONTROLS',
  CRITICAL_VARIABLES = 'CRITICAL_VARIABLES',
  CRITICAL_VARIABLES_AND_CONTROLS = 'CRITICAL_VARIABLES_AND_CONTROLS',
  CRITICAL_VARIABLES_AND_FUNCTIONAL_DATA_REVIEWS = 'CRITICAL_VARIABLES_AND_FUNCTIONAL_DATA_REVIEWS',
  FUNCTIONAL_DATA_REVIEWS = 'FUNCTIONAL_DATA_REVIEWS',
  OBSERVATIONS = 'OBSERVATIONS',
  OBSERVATIONS_AND_ACTIONS = 'OBSERVATIONS_AND_ACTIONS',
  RISKS = 'RISKS',
  RISKS_AND_CM_CONTROL_HUB_CHARTS = 'RISKS_AND_CM_CONTROL_HUB_CHARTS',
  RISKS_AND_CONTROLS = 'RISKS_AND_CONTROLS',
  RISKS_AND_CRITICAL_VARIABLES = 'RISKS_AND_CRITICAL_VARIABLES'
}

export type ReportSignatoryInput = {
  firstName?: string | null | undefined;
  id?: any;
  lastName?: string | null | undefined;
  recordId?: any;
  role?: ReportSignatoryRole | null | undefined;
  studyId?: any;
  template?: string | null | undefined;
  title?: string | null | undefined;
};

export enum ReportSignatoryRole {
  APPROVER = 'APPROVER',
  AUTHOR = 'AUTHOR',
  REVIEWER = 'REVIEWER'
}

export enum ReportStatus {
  FINAL = 'FINAL',
  OBSOLETE = 'OBSOLETE',
  PREVIEW = 'PREVIEW'
}

export type RiskActionInput = {
  comments?: string | null | undefined;
  completedDate?: any;
  description?: string | null | undefined;
  expectedCompleteDate?: any;
  id?: any;
  ownerId?: any;
  recordId?: any;
  requestDate?: any;
  responsibleFunctionId?: any;
  result?: string | null | undefined;
  type?: RiskActionType | null | undefined;
};

export enum RiskActionType {
  CORRECTIVE = 'CORRECTIVE',
  NONE = 'NONE',
  PREVENTATIVE = 'PREVENTATIVE'
}

export type RiskAssessmentTagInput = {
  active?: boolean | null | undefined;
  id?: any;
  name?: string | null | undefined;
  studyId?: any;
};

export type RiskDashboardConfigInput = {
  organisationId?: any;
  panels?: Array<RiskDashboardPanelDataInput | null | undefined> | null | undefined;
};

export enum RiskDashboardPanel {
  RISK_CATEGORIES = 'RISK_CATEGORIES',
  RISK_MAP = 'RISK_MAP',
  RISK_REVIEW_STATUS = 'RISK_REVIEW_STATUS',
  STUDY_RISK_TRENDS = 'STUDY_RISK_TRENDS'
}

export type RiskDashboardPanelDataInput = {
  displayOrder?: any;
  panelId?: RiskDashboardPanel | null | undefined;
};

export enum RiskEvaluationColor {
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  NONE = 'NONE',
  RED = 'RED'
}

export type RiskEvaluationInput = {
  changeReason?: string | null | undefined;
  detectability?: any;
  evaluationModelId?: any;
  id?: any;
  impact?: any;
  likelihood?: any;
  rationale?: string | null | undefined;
  recordId?: any;
  type?: RiskEvaluationType | null | undefined;
};

export type RiskEvaluationModelInput = {
  active?: boolean | null | undefined;
  detectability?: Array<RiskEvaluationModelItemInput | null | undefined> | null | undefined;
  id?: any;
  impact?: Array<RiskEvaluationModelItemInput | null | undefined> | null | undefined;
  includeDetectability?: boolean | null | undefined;
  likelihood?: Array<RiskEvaluationModelItemInput | null | undefined> | null | undefined;
  name?: string | null | undefined;
  ragMap?: Array<RAGInput | null | undefined> | null | undefined;
  recordId?: any;
  reviewPeriodDays?: any;
};

export type RiskEvaluationModelItemInput = {
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  label?: string | null | undefined;
  value?: any;
};

export enum RiskEvaluationScoreTrendType {
  FALLING = 'FALLING',
  NO_MOVEMENT = 'NO_MOVEMENT',
  NO_TREND = 'NO_TREND',
  RISING = 'RISING',
  STABLE = 'STABLE'
}

export enum RiskEvaluationType {
  ORIGINAL = 'ORIGINAL',
  RESCORE = 'RESCORE'
}

export type RiskInput = {
  active?: boolean | null | undefined;
  categoryId?: any;
  closedDate?: any;
  controlStrategyId?: any;
  controls?: Array<any> | null | undefined;
  countries?: Array<CountryInputType | null | undefined> | null | undefined;
  dateIdentified?: any;
  dateLastReviewed?: any;
  id?: any;
  internalOnly?: boolean | null | undefined;
  libraryReferenceId?: any;
  ownerId?: any;
  qualityIssueId?: any;
  qualityIssueReference?: string | null | undefined;
  recordId?: any;
  responsibleFunctionId?: any;
  reviewFrequencyPeriod?: any;
  reviewFrequencyUnits?: TimeFrequencyType | null | undefined;
  reviewRequired?: boolean | null | undefined;
  statement?: string | null | undefined;
  status?: RiskStatusType | null | undefined;
  studyId?: any;
  vendorIds?: Array<any> | null | undefined;
};

export type RiskObservationInput = {
  classificationId?: any;
  closedDate?: any;
  comments?: string | null | undefined;
  confirmedCause?: string | null | undefined;
  countries?: Array<CountryInputType | null | undefined> | null | undefined;
  description?: string | null | undefined;
  id?: any;
  observationDate?: any;
  ownerId?: any;
  potentialCause?: string | null | undefined;
  qtlExceeded?: boolean | null | undefined;
  recordId?: any;
  resolution?: string | null | undefined;
  responsibleFunctionId?: any;
  riskId?: any;
  studyId?: any;
  vendorIds?: Array<any> | null | undefined;
};

export type RiskPocCommentInput = {
  /** The ID of this comment. */
  id?: string | null | undefined;
  /** The ID of the risk this comment is associated with. */
  parentId: string;
  /** The ID of the publisher of this comment. */
  publisherUserId: string;
};

export enum RiskReviewStatusType {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_REVIEWED = 'NOT_REVIEWED',
  REVIEWED = 'REVIEWED',
  REVIEW_DUE = 'REVIEW_DUE',
  REVIEW_NOT_REQUIRED = 'REVIEW_NOT_REQUIRED',
  REVIEW_OVERDUE = 'REVIEW_OVERDUE'
}

export enum RiskStatusType {
  ASSESSED = 'ASSESSED',
  CLOSED = 'CLOSED',
  CONTROLLED = 'CONTROLLED',
  DRAFT = 'DRAFT',
  IDENTIFIED = 'IDENTIFIED',
  /** Not Applicable */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  OBSOLETE = 'OBSOLETE',
  TRIGGERED = 'TRIGGERED'
}

export enum RowDataSourceTable {
  NONE = 'NONE',
  SITE = 'SITE',
  SITE_ISSUE = 'SITE_ISSUE',
  SITE_PROTOCOL_DEVIATION = 'SITE_PROTOCOL_DEVIATION',
  SITE_VISIT = 'SITE_VISIT',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT',
  SUBJECT_ADVERSE_EVENT = 'SUBJECT_ADVERSE_EVENT',
  SUBJECT_ASSESSMENT = 'SUBJECT_ASSESSMENT',
  SUBJECT_CONCOMITANT_MEDICATION = 'SUBJECT_CONCOMITANT_MEDICATION',
  SUBJECT_CRF = 'SUBJECT_CRF',
  SUBJECT_INFORMED_CONSENT = 'SUBJECT_INFORMED_CONSENT',
  SUBJECT_ISSUE = 'SUBJECT_ISSUE',
  SUBJECT_LAB = 'SUBJECT_LAB',
  SUBJECT_MEDICAL_HISTORY = 'SUBJECT_MEDICAL_HISTORY',
  SUBJECT_PROTOCOL_DEVIATION = 'SUBJECT_PROTOCOL_DEVIATION',
  SUBJECT_QUERY = 'SUBJECT_QUERY',
  SUBJECT_VISIT = 'SUBJECT_VISIT'
}

export enum RowDataSourceTag {
  DATA_TABLE = 'DATA_TABLE',
  DATA_TABLE_DATA_LISTING = 'DATA_TABLE_DATA_LISTING',
  DATA_TABLE_SITE_SUMMARY = 'DATA_TABLE_SITE_SUMMARY',
  DATA_TABLE_SUBJECT_SUMMARY = 'DATA_TABLE_SUBJECT_SUMMARY',
  PANEL = 'PANEL',
  SITE_LISTING = 'SITE_LISTING'
}

export enum RuleClauseEnumType {
  AND = 'AND',
  NONE = 'NONE',
  OR = 'OR'
}

export enum RuleClauseOperatorEnumType {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_EQUALS = 'GREATER_THAN_EQUALS',
  IN = 'IN',
  IS_BLANK = 'IS_BLANK',
  IS_NOT_BLANK = 'IS_NOT_BLANK',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUALS = 'LESS_THAN_EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_IN = 'NOT_IN'
}

export type RuleInput = {
  comparatorField?: string | null | undefined;
  id?: any;
  index?: number | null | undefined;
  ruleClause?: RuleClauseEnumType | null | undefined;
  ruleClauseOperator?: RuleClauseOperatorEnumType | null | undefined;
  value?: any;
};

export enum ScoreColourType {
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  GREY = 'GREY',
  NONE = 'NONE',
  PURPLE = 'PURPLE',
  RED = 'RED'
}

export type SelectorData = {
  id: any;
  version: number;
};

export type SeriesRowDataInput = {
  rule?: TimelineRuleInput | null | undefined;
  source: string;
};

export enum SiteAverage {
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN'
}

export type SmStudyMemberInput = {
  active?: boolean | null | undefined;
  defaultSiteId?: any;
  email?: string | null | undefined;
  favourite?: boolean | null | undefined;
  favouriteSiteIds?: Array<any> | null | undefined;
  firstName?: string | null | undefined;
  id?: any;
  isAdmin?: boolean | null | undefined;
  lastName?: string | null | undefined;
  recordId?: any;
  status?: StudyMemberStatus | null | undefined;
  userId?: any;
};

export enum StableVariableType {
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE'
}

export type StudyAssessmentInput = {
  active?: boolean | null | undefined;
  assessmentRules?: Array<RuleInput | null | undefined> | null | undefined;
  completedFieldName?: string | null | undefined;
  configId?: any;
  crfId?: any;
  endPoint?: boolean | null | undefined;
  id?: any;
  lab?: boolean | null | undefined;
  name?: string | null | undefined;
  recordId?: any;
  safety?: boolean | null | undefined;
  sendToVendor?: boolean | null | undefined;
};

export enum StudyAutomationColor {
  NONE = 'NONE',
  RED_AMBER = 'RED_AMBER',
  RED_AMBER_PURPLE = 'RED_AMBER_PURPLE',
  RED_ONLY = 'RED_ONLY',
  RED_PURPLE = 'RED_PURPLE'
}

export type StudyCohortInput = {
  active?: boolean | null | undefined;
  configId?: any;
  description?: string | null | undefined;
  id?: any;
  name?: string | null | undefined;
  recordId?: any;
  subjectCode?: string | null | undefined;
};

export enum StudyConfigurationImportType {
  ASSESSMENTS = 'ASSESSMENTS',
  COHORTS = 'COHORTS',
  CONTROLS_HUB_CONFIG_PANEL = 'CONTROLS_HUB_CONFIG_PANEL',
  CONTROLS_HUB_CONFIG_WIDGET = 'CONTROLS_HUB_CONFIG_WIDGET',
  CONTROLS_HUB_WIDGETS = 'CONTROLS_HUB_WIDGETS',
  CR_FS = 'CR_FS',
  DASHBOARDS = 'DASHBOARDS',
  DASHBOARD_WIDGET = 'DASHBOARD_WIDGET',
  DATA_FILTERS = 'DATA_FILTERS',
  DATA_LISTINGS_CONFIGURATION = 'DATA_LISTINGS_CONFIGURATION',
  DATA_LISTING_CONFIGURATION = 'DATA_LISTING_CONFIGURATION',
  DATA_TABLES = 'DATA_TABLES',
  DATA_VIEW_CONFIGURATION = 'DATA_VIEW_CONFIGURATION',
  EXTRA_DATA_FIELDS = 'EXTRA_DATA_FIELDS',
  PANELS = 'PANELS',
  SITE_DATA_FILTERS = 'SITE_DATA_FILTERS',
  STUDIES = 'STUDIES',
  STUDY_DASHBOARD_CONFIG = 'STUDY_DASHBOARD_CONFIG',
  STUDY_DASHBOARD_CONFIG_PANEL = 'STUDY_DASHBOARD_CONFIG_PANEL',
  STUDY_HUB_SITE_FIELDS_CONFIG = 'STUDY_HUB_SITE_FIELDS_CONFIG',
  STUDY_HUB_STUDY_FIELDS_CONFIG = 'STUDY_HUB_STUDY_FIELDS_CONFIG',
  STUDY_VISIT = 'STUDY_VISIT',
  SUBJECT_DATA_FILTERS = 'SUBJECT_DATA_FILTERS',
  SUBJECT_HUB_OVERVIEW_GRID_CONFIGURATION = 'SUBJECT_HUB_OVERVIEW_GRID_CONFIGURATION',
  SUBJECT_PROFILE_DETAILS_CONFIGURATION = 'SUBJECT_PROFILE_DETAILS_CONFIGURATION',
  SV_TS = 'SV_TS',
  TREATMENT_ARMS = 'TREATMENT_ARMS',
  WIDGETS = 'WIDGETS'
}

export type StudyControlInput = {
  actionToBeTaken?: string | null | undefined;
  activeDate?: any;
  additionalInformation?: string | null | undefined;
  controlPhaseId?: any;
  dateIdentified?: any;
  description?: string | null | undefined;
  id?: any;
  inactiveDate?: any;
  libraryControlId?: any;
  ownerId?: any;
  phase?: PhaseType | null | undefined;
  purpose?: string | null | undefined;
  recordId?: any;
  responsibleFunctionId?: any;
  reviewFrequencyPeriod?: any;
  reviewFrequencyUnits?: TimeFrequencyType | null | undefined;
  studyId?: any;
  threshold?: string | null | undefined;
  typeId?: any;
  volume?: string | null | undefined;
};

export type StudyCrfInput = {
  active?: boolean | null | undefined;
  configId?: any;
  crfName?: string | null | undefined;
  crfRules?: Array<RuleInput | null | undefined> | null | undefined;
  id?: any;
  recordId?: any;
  required?: boolean | null | undefined;
  subjectCode?: string | null | undefined;
};

export type StudyDashboardConfigWidgetInputType = {
  displayName?: string | null | undefined;
  fieldKey?: string | null | undefined;
  fieldName?: string | null | undefined;
  iconName?: number | null | undefined;
  id?: any;
  recordId?: any;
  studyId?: any;
  tableCode?: number | null | undefined;
  typeCode?: number | null | undefined;
  useOnSiteGrid?: boolean | null | undefined;
};

export type StudyDashboardConfigurationInput = {
  dataSetFilter?: number | null | undefined;
  dataSetsCount?: number | null | undefined;
  id?: any;
};

export type StudyHubMonitoringToolkitConfigInput = {
  allowKRIReviews?: boolean | null | undefined;
  id?: any;
};

export type StudyHubPanelLineSelectorConfigInput = {
  id?: any;
  studyRate?: boolean | null | undefined;
  studySiteMean?: boolean | null | undefined;
};

export type StudyHubSiteFieldsConfigInput = {
  activeDate?: boolean | null | undefined;
  closedDate?: boolean | null | undefined;
  investigator?: boolean | null | undefined;
  monitor?: boolean | null | undefined;
  numAmberDecisionMakingKRIs?: boolean | null | undefined;
  numAmberKRIs?: boolean | null | undefined;
  numGreenDecisionMakingKRIs?: boolean | null | undefined;
  numGreenKRIs?: boolean | null | undefined;
  numRedDecisionMakingKRIs?: boolean | null | undefined;
  numRedKRIs?: boolean | null | undefined;
  score?: boolean | null | undefined;
};

export type StudyHubStudyFieldsConfigInput = {
  countrySiteMean?: boolean | null | undefined;
  numAmberSites?: boolean | null | undefined;
  numGreenSites?: boolean | null | undefined;
  numRedSites?: boolean | null | undefined;
  siteRate?: boolean | null | undefined;
  studyRate?: boolean | null | undefined;
  studySiteMean?: boolean | null | undefined;
};

export type StudyInput = {
  adjustmentWeight?: any;
  assessmentAssociation?: boolean | null | undefined;
  automationActive?: boolean | null | undefined;
  calculateAssessments?: boolean | null | undefined;
  calculateCrfs?: boolean | null | undefined;
  calculateVisits?: boolean | null | undefined;
  centralMonitoringFirstDataLoadDate?: any;
  centralMonitoringReleaseDate?: any;
  code?: string | null | undefined;
  configId?: any;
  controlsAutomationActive?: boolean | null | undefined;
  controlsAutomationColor: ControlsAutomationColor;
  displayRiskOverviewOnStudySummary?: boolean | null | undefined;
  displayStudyOverviewOnStudySummary?: boolean | null | undefined;
  displayStudySiteOverviewOnStudySummary?: boolean | null | undefined;
  evaluationModelId?: any;
  id?: any;
  importDefinitionsKey?: string | null | undefined;
  indications?: Array<any> | null | undefined;
  integrationActive?: boolean | null | undefined;
  integrationStudyNumber?: string | null | undefined;
  lastSubjectEnrolledDate?: any;
  lastSubjectRandomisedDate?: any;
  lastSubjectScreenedDate?: any;
  products?: Array<any> | null | undefined;
  programs?: Array<any> | null | undefined;
  recordId?: any;
  riskAssessmentAwardStartDate?: any;
  riskAssessmentIsmpStartDate?: any;
  riskAssessmentRfpStartDate?: any;
  riskLibraryCategoryIds?: Array<any> | null | undefined;
  riskOverviewConfiguration?: StudyRiskOverviewConfigurationInput | null | undefined;
  riskReviewWindowDays?: any;
  scoreAmberThreshold?: any;
  scoreGreenThreshold?: any;
  scoreThreshold?: any;
  shortName?: string | null | undefined;
  siteSummaryConfiguration?: StudySiteSummaryConfigurationInput | null | undefined;
  sitesStatusesToExclude?: Array<string | null | undefined> | null | undefined;
  sitesStatusesToExcludeFromAutomation?: Array<string | null | undefined> | null | undefined;
  sitesToExclude?: Array<any> | null | undefined;
  sponsor?: string | null | undefined;
  studyAutomationColor: StudyAutomationColor;
  studyFunctionIds?: Array<any> | null | undefined;
  studyNumber?: string | null | undefined;
  studyOverviewTableConfiguration?: StudyOverviewTableConfigurationInputType | null | undefined;
  studySiteOverviewTableConfiguration?: StudySiteOverviewTableConfigurationInputType | null | undefined;
  studySummaryConfiguration?: StudySummaryConfigurationInput | null | undefined;
  svtDependency?: SvtDependencyType | null | undefined;
  title?: string | null | undefined;
  useInformedConsentedDate?: boolean | null | undefined;
  useLatestCentralMonitoring?: boolean | null | undefined;
  volumeAdjustedScoring?: boolean | null | undefined;
  volumeAdjustedScoringNumberField?: string | null | undefined;
};

export type StudyMemberInput = {
  active?: boolean | null | undefined;
  defaultSiteId?: any;
  email?: string | null | undefined;
  favourite?: boolean | null | undefined;
  favouriteSiteIds?: Array<any> | null | undefined;
  firstName?: string | null | undefined;
  id?: any;
  isAdmin?: boolean | null | undefined;
  lastName?: string | null | undefined;
  recordId?: any;
  status?: StudyMemberStatus | null | undefined;
  userId?: any;
};

export enum StudyMemberStatus {
  DISABLED = 'DISABLED',
  INVITED = 'INVITED',
  JOINED = 'JOINED',
  VIRTUAL = 'VIRTUAL'
}

export type StudyOverviewColumnConfigurationInput = {
  calculation?: string | null | undefined;
  dataSource?: RowDataSourceTable | null | undefined;
  default?: boolean | null | undefined;
  fields?: string | null | undefined;
  name?: string | null | undefined;
  order?: number | null | undefined;
  type?: OverviewColumnConfigurationEnumType | null | undefined;
};

export type StudyOverviewExtraColumnInput = {
  columnId?: any;
  dataField?: string | null | undefined;
  dataSource?: RowDataSourceTable | null | undefined;
  denominatorField?: string | null | undefined;
  label?: string | null | undefined;
  numeratorField?: string | null | undefined;
  type?: StudyOverviewExtraColumnType | null | undefined;
};

export enum StudyOverviewExtraColumnType {
  RATE = 'RATE',
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN'
}

export type StudyOverviewPanelConfigurationInput = {
  panelId?: any;
  panelOrder?: number | null | undefined;
};

export type StudyOverviewTableConfigurationInputType = {
  columnConfigurations?: Array<StudyOverviewColumnConfigurationInput | null | undefined> | null | undefined;
  panelConfigurations?: Array<StudyOverviewPanelConfigurationInput | null | undefined> | null | undefined;
};

export type StudyRiskOverviewConfigurationInput = {
  amberDecisionKris?: boolean | null | undefined;
  amberKris?: boolean | null | undefined;
  numSubjects?: boolean | null | undefined;
  redDecisionKris?: boolean | null | undefined;
  redKris?: boolean | null | undefined;
  siteActiveDate?: boolean | null | undefined;
  siteCountry?: boolean | null | undefined;
  siteMonitor?: boolean | null | undefined;
  siteStatus?: boolean | null | undefined;
  subjectField?: string | null | undefined;
};

export type StudySiteOverviewColumnConfigurationInput = {
  calculation?: string | null | undefined;
  dataSource?: RowDataSourceTable | null | undefined;
  default?: boolean | null | undefined;
  fields?: string | null | undefined;
  name?: string | null | undefined;
  order?: number | null | undefined;
  type?: OverviewColumnConfigurationEnumType | null | undefined;
};

export type StudySiteOverviewTableConfigurationInputType = {
  columnConfigurations?: Array<StudySiteOverviewColumnConfigurationInput | null | undefined> | null | undefined;
  panelConfigurations?: Array<StudyOverviewPanelConfigurationInput | null | undefined> | null | undefined;
  rowOrder?: OverviewRowOrderConfigurationEnumType | null | undefined;
};

export type StudySiteSummaryConfigurationInput = {
  actionChart?: boolean | null | undefined;
  monitor?: boolean | null | undefined;
  numCompleted?: boolean | null | undefined;
  numEnrolled?: boolean | null | undefined;
  numRandomised?: boolean | null | undefined;
  numScreenFailed?: boolean | null | undefined;
  numScreened?: boolean | null | undefined;
  numStudyDiscontinued?: boolean | null | undefined;
  numTreatmentDiscontinued?: boolean | null | undefined;
  observationChart?: boolean | null | undefined;
  siteActiveDate?: boolean | null | undefined;
  siteCountry?: boolean | null | undefined;
  siteStatus?: boolean | null | undefined;
};

export type StudySubjectVisitInput = {
  active?: boolean | null | undefined;
  configId?: any;
  eventIds?: Array<any> | null | undefined;
  forecastEndDateField?: string | null | undefined;
  id?: any;
  isEndDateEarliest?: boolean | null | undefined;
  leadPeriod?: any;
  leadUnit?: StudyTimeUnit | null | undefined;
  leadVisitId?: any;
  leadVisitName?: string | null | undefined;
  maxOccurrences?: any;
  maxWinPeriod?: any;
  maxWinUnit?: StudyTimeUnit | null | undefined;
  minOccurrences?: any;
  minWinPeriod?: any;
  minWinUnit?: StudyTimeUnit | null | undefined;
  recordId?: any;
  sequenceNumber?: any;
  studyId?: any;
  type?: string | null | undefined;
  visitId?: string | null | undefined;
  visitName?: string | null | undefined;
};

export type StudySubjectVisitScheduleTemplateInput = {
  active?: boolean | null | undefined;
  cohortIds?: Array<any> | null | undefined;
  configId?: any;
  description?: string | null | undefined;
  groupId?: number | null | undefined;
  id?: any;
  name?: string | null | undefined;
  recordId?: any;
  studyId?: any;
  treatmentArmIds?: Array<any> | null | undefined;
  version?: string | null | undefined;
  versionDate?: NullablePartialDateTimeInput | null | undefined;
};

export type StudySubjectVisitSequenceInputType = {
  sequenceNumber?: number | null | undefined;
  visitId?: any;
};

export type StudySummaryConfigurationInput = {
  numCompleted?: boolean | null | undefined;
  numEnrolled?: boolean | null | undefined;
  numRandomised?: boolean | null | undefined;
  numScreenFailed?: boolean | null | undefined;
  numScreened?: boolean | null | undefined;
  numStudyDiscontinued?: boolean | null | undefined;
  numTreatmentDiscontinued?: boolean | null | undefined;
};

export enum StudyTimeUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NONE = 'NONE',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export type StudyTreatmentArmInput = {
  active?: boolean | null | undefined;
  configId?: any;
  description?: string | null | undefined;
  id?: any;
  name?: string | null | undefined;
  recordId?: any;
  subjectCode?: string | null | undefined;
};

export type SubjectHubConfigField = {
  displayIndex?: number | null | undefined;
  key?: string | null | undefined;
  label?: string | null | undefined;
  name?: string | null | undefined;
  type?: string | null | undefined;
};

export enum SubjectPDClassification {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  NONE = 'NONE'
}

export type SubjectProfileDetailsConfigurationItemInput = {
  personalInformation?: SubjectProfileDetailsConfigurationItemPersonalInformationInput | null | undefined;
  siteInformation?: SubjectProfileDetailsConfigurationItemSiteInformationInput | null | undefined;
  subjectStatus?: SubjectProfileDetailsConfigurationItemSubjectStatusInput | null | undefined;
  timeline?: SubjectProfileDetailsConfigurationItemTimelineInput | null | undefined;
  treatmentStatus?: SubjectProfileDetailsConfigurationItemTreatmentStatusInput | null | undefined;
};

export type SubjectProfileDetailsConfigurationItemPersonalInformationInput = {
  ageAtEnrolment?: boolean | null | undefined;
  ethnicity?: boolean | null | undefined;
  gender?: boolean | null | undefined;
  label?: string | null | undefined;
  latestConsentDate?: boolean | null | undefined;
  latestConsentVersion?: boolean | null | undefined;
  race?: boolean | null | undefined;
};

export type SubjectProfileDetailsConfigurationItemSiteInformationInput = {
  activeDate?: boolean | null | undefined;
  closedDate?: boolean | null | undefined;
  country?: boolean | null | undefined;
  investigatorName?: boolean | null | undefined;
  label?: string | null | undefined;
  monitor?: boolean | null | undefined;
  numberOfAESIs?: boolean | null | undefined;
  numberOfAEs?: boolean | null | undefined;
  numberOfPDs?: boolean | null | undefined;
  numberOfQueriesOpenAll?: boolean | null | undefined;
  numberOfSAEs?: boolean | null | undefined;
  status?: boolean | null | undefined;
  subjectEnrolled?: boolean | null | undefined;
  subjectRandomized?: boolean | null | undefined;
  subjectTxDisc?: boolean | null | undefined;
  subjectTxStart?: boolean | null | undefined;
  subjectsFUComplete?: boolean | null | undefined;
  subjectsFUStart?: boolean | null | undefined;
  subjectsScreenFailed?: boolean | null | undefined;
  subjectsScreened?: boolean | null | undefined;
  subjectsTxComplete?: boolean | null | undefined;
};

export type SubjectProfileDetailsConfigurationItemSubjectStatusInput = {
  combiAssessments?: boolean | null | undefined;
  combiVisits?: boolean | null | undefined;
  enrolled?: boolean | null | undefined;
  fUCompleted?: boolean | null | undefined;
  fUStart?: boolean | null | undefined;
  label?: string | null | undefined;
  lastVisitNameAndDate?: boolean | null | undefined;
  numberOfAESIs?: boolean | null | undefined;
  numberOfAEs?: boolean | null | undefined;
  numberOfPDs?: boolean | null | undefined;
  numberOfQueriesOpenAll?: boolean | null | undefined;
  numberOfSAEs?: boolean | null | undefined;
  randomized?: boolean | null | undefined;
  screenFail?: boolean | null | undefined;
  screenFailReason?: boolean | null | undefined;
  screening?: boolean | null | undefined;
  status?: boolean | null | undefined;
  studyDisc?: boolean | null | undefined;
  studyDiscReason?: boolean | null | undefined;
};

export type SubjectProfileDetailsConfigurationItemTimelineInput = {
  endDateFields?: Array<string> | null | undefined;
  milestoneDateFields?: Array<string> | null | undefined;
  panels?: Array<SubjectProfileDetailsConfigurationItemTimelinePanelInput> | null | undefined;
  showTagsAsMilestones?: boolean | null | undefined;
  sortAscending?: boolean | null | undefined;
  startDate?: any;
};

export type SubjectProfileDetailsConfigurationItemTimelinePanelInput = {
  id: any;
  plotTitle: string;
};

export type SubjectProfileDetailsConfigurationItemTreatmentStatusInput = {
  cohort?: boolean | null | undefined;
  label?: string | null | undefined;
  treatmentArm?: boolean | null | undefined;
  txCompleted?: boolean | null | undefined;
  txDisc?: boolean | null | undefined;
  txDiscReason?: boolean | null | undefined;
  txStart?: boolean | null | undefined;
};

export enum SubjectQueryType {
  MANUAL = 'MANUAL',
  SYSTEM = 'SYSTEM'
}

export enum SubjectVisitStatus {
  COMPLETED = 'COMPLETED',
  MISSING = 'MISSING',
  NONE = 'NONE',
  NOT_DONE = 'NOT_DONE',
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED = 'UNSCHEDULED'
}

export enum SvtDependencyType {
  BOTH = 'BOTH',
  COHORTS = 'COHORTS',
  NONE = 'NONE',
  TREATMENT_ARMS = 'TREATMENT_ARMS'
}

export enum ThresholdCalculation {
  MEAN_SD = 'MEAN_SD',
  POISSON = 'POISSON',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum TimeFrequencyType {
  ANNUALLY = 'ANNUALLY',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  NONE = 'NONE',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY'
}

export enum TimelineAxisType {
  DATE = 'DATE',
  NONE = 'NONE',
  NUMERIC = 'NUMERIC'
}

export enum TimelineDateSeriesType {
  DATE_RANGE = 'DATE_RANGE',
  SINGLE_DATE = 'SINGLE_DATE'
}

export enum TimelineFieldLogicalOperator {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  ENDS_WITH = 'ENDS_WITH',
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  IS_BLANK = 'IS_BLANK',
  IS_NOT_BLANK = 'IS_NOT_BLANK',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  STARTS_WITH = 'STARTS_WITH'
}

export type TimelineInput = {
  leftAxis: AxisInput;
  rightAxis?: AxisInput | null | undefined;
};

export enum TimelineNumericSeriesType {
  LINE = 'LINE',
  SCATTER = 'SCATTER'
}

export type TimelineRuleInput = {
  field1: string;
  field2?: string | null | undefined;
  logicalOperator?: TimelineRuleLogicalOperator | null | undefined;
  operator1: TimelineFieldLogicalOperator;
  operator2?: TimelineFieldLogicalOperator | null | undefined;
  value1?: any;
  value2?: any;
};

export enum TimelineRuleLogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export type TriOpDateParametersInput = {
  amberMaxScore?: any;
  amberThreshold?: number | null | undefined;
  bigRedThreshold?: number | null | undefined;
  dataInclusionPeriod?: PanelTimePeriod | null | undefined;
  dataInclusionUnit?: any;
  dataPopulation?: DataPopulation | null | undefined;
  greenMaxScore?: any;
  minDataNeeded?: any;
  redThreshold?: number | null | undefined;
  rowData?: string | null | undefined;
  siteAverage?: SiteAverage | null | undefined;
  sortField?: string | null | undefined;
  stableValue?: number | null | undefined;
  stableVariableType?: StableVariableType | null | undefined;
  thresholdCalculation?: ThresholdCalculation | null | undefined;
  xAxisTitle?: string | null | undefined;
  yAxisColumnValue?: string | null | undefined;
  yAxisDataField?: string | null | undefined;
  yAxisTitle?: string | null | undefined;
};

export type UpdateCommentInput = {
  content: string;
  entityType: string;
  id: any;
  replySelectors: Array<SelectorData>;
};

export type UpdateCommentReplyInput = {
  content: string;
  entityType: string;
  id: any;
  replySelectors: Array<SelectorData>;
};

export type UpdatedCommentsByIdInput = {
  commentIds: Array<any>;
  commentSelectors: Array<CommentSelector>;
  entityType: string;
  parentId: any;
};

export type UpdatedCommentsInput = {
  commentSelectors: Array<CommentSelector>;
  entityType: string;
  parentId: any;
};

export enum UserLevel {
  ORGANISATION = 'ORGANISATION',
  SYSTEM = 'SYSTEM'
}

export enum UserStatus {
  JOINED = 'JOINED',
  VERIFYING = 'VERIFYING'
}
